"use strict";

/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */
function showConsentModal() {
    var $trackingConsent = $(".tracking-consent");

    if (!$trackingConsent.data("caonline")) {
        return;
    }

    var urlContent = $trackingConsent.data("url");
    var urlAccept = $trackingConsent.data("accept");
    var urlReject = $trackingConsent.data("reject");
    var textYes = $trackingConsent.data("accepttext");
    var textNo = $trackingConsent.data("rejecttext");
    var textHeader = $trackingConsent.data("heading");

    var htmlString = "<!-- Modal -->"
        + "<div class=\"modal show\" id=\"consent-tracking\" role=\"dialog\" style=\"display: block;\">"
        + "<div class=\"modal-dialog\">"
        + "<!-- Modal content-->"
        + "<div class=\"modal-content\">"
        + "<div class=\"modal-header\">"
        + textHeader
        + "</div>"
        + "<div class=\"modal-body\"></div>"
        + "<div class=\"modal-footer\">"
        + "<div class=\"button-wrapper\">"
        + "<button class=\"affirm btn btn-primary\" data-url=\"" + urlAccept + "\">"
        + textYes
        + "</button>"
        + "<button class=\"decline btn btn-primary\" data-url=\"" + urlReject + "\">"
        + textNo
        + "</button>"
        + "</div>"
        + "</div>"
        + "</div>"
        + "</div>"
        + "</div>";
    $.spinner().start();
    $("body").append(htmlString);

    $.ajax({
        url: urlContent,
        type: "get",
        dataType: "html",
        success: function (response) {
            $(".modal-body").html(response);
        },
        error: function () {
            $("#consent-tracking").remove();
        }
    });

    $("#consent-tracking .button-wrapper button").click(function (e) {
        e.preventDefault();
        var url = $(this).data("url");
        $.ajax({
            url: url,
            type: "get",
            dataType: "json",
            success: function () {
                $("#consent-tracking").remove();
                $.spinner().stop();
            },
            error: function () {
                $("#consent-tracking").remove();
                $.spinner().stop();
            }
        });
    });
}

module.exports = function () {
    var $trackingConsent = $(".tracking-consent");
    var $trackingConsentClass = $trackingConsent.hasClass("api-true");

    if ($(".consented").length === 0 && $trackingConsentClass) {
        showConsentModal();
    }

    if ($trackingConsentClass) {
        $trackingConsent.click(function () {
            showConsentModal();
        });
    }
};
